import { createContext, useContext, type ReactNode } from "react";

import { NOOP_ANALYTICS, type Analytics } from "./analytics";

// The console has many surfaces across routed pages — a context beats prop-drilling here.
// Default is the frozen no-op, so surfaces and their tests never need a provider to render.

const AnalyticsContext = createContext<Analytics>(NOOP_ANALYTICS);

export function AnalyticsProvider({ analytics, children }: { analytics: Analytics; children: ReactNode }) {
  return <AnalyticsContext.Provider value={analytics}>{children}</AnalyticsContext.Provider>;
}

export function useAnalytics(): Analytics {
  return useContext(AnalyticsContext);
}
